import { useToast } from 'native-base';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import Pay from './Pay';
import store from '../../../store';

function PayContainer({ onStepSet }) {
  const [isCompleted, setCompleted] = useState(false);
  const cost = useSelector((state) => state.wallet.cost);
  const paymentContent = useSelector((state) => state.wallet.paymentContent);
  const paymentTotal = useSelector(store.select.wallet.paymentTotal);
  const toast = useToast();
  const onDone = useCallback(() => {
    if (!isCompleted) {
      toast.show({
        title: "Vous n'avez pas encore donné toute la monnaie.",
        placement: 'top',
        status: 'error',
      });
    } else if (cost === paymentTotal) {
      onStepSet(4);
    } else {
      onStepSet(3);
    }
  }, [cost, isCompleted, onStepSet, paymentTotal, toast]);
  return (
    <Pay
      onDone={onDone}
      paymentContent={paymentContent}
      paymentTotal={paymentTotal}
      setCompleted={setCompleted}
    />
  );
}

PayContainer.propTypes = {
  onStepSet: PropTypes.func.isRequired,
};

export default PayContainer;
